import React from 'react';
import styled from '@emotion/styled';
import { t } from 'services/translation';
import { AnyRoadLogoGrayFooter2023 } from 'views/anyguide/layout/logo/images/AnyRoadLogoGrayFooter2023.tsx';
import { colors } from 'ui_system/compass';

import './index.scss';

const Bullet = styled.span`
  color: ${colors.text.icon};
  font-size: 10px;
  margin: 0 8px;
`;

class PoweredBy extends React.Component {
  _link = (linkDestination, linkText) => {
    const styling = {};
    return (
      <a
        target="_blank"
        className="terms-link"
        style={styling}
        rel="noopener noreferrer"
        href={linkDestination}
      >
        {linkText}
      </a>
    );
  };

  render() {
    const { hidePolicyLinks } = this.props;
    return (
      <p className="PoweredBy">
        <a
          aria-label="Anyroad logo a link to the landing page"
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.anyroad.com/"
        >
          <AnyRoadLogoGrayFooter2023 className="Logo" />
        </a>
        {!hidePolicyLinks && (
          <div className="terms-links-container">
            {this._link(
              'https://www.anyroad.com/end-user-terms',
              t('TERMS_OF_SERVICE')
            )}
            <Bullet>●</Bullet>
            {this._link('https://www.anyroad.com/privacy', t('PRIVACY_POLICY'))}
          </div>
        )}
      </p>
    );
  }
}

export default PoweredBy;
